export const API_RELEASE_VERSION = "1.0";
export const RETURN_URL = "returnUrl";
export const SPIN_DELAY = 400;
export const TABLE_DEBOUNCE_DELAY = 400;
export const DISPLAY_DATE_FORMAT = "D MMMM YYYY";
